import { OrderingInitialState, SetIsNewAction } from '@reducers/ordering/types';

export const setIsNew = (state: OrderingInitialState, action: SetIsNewAction): OrderingInitialState => ({
  ...state,
  couponState: {
    ...state.couponState,
    isNew: action.payload,
  },
});
